type RedactedProps = {
  text: string;
  className?: string;
};

export function Redacted({ text, className = '' }: RedactedProps) {
  return (
    <span className={`redacted ${className}`}>
      <span className="sr-only">{text}</span>
      <span aria-hidden="true" className="redacted__face">
        {'█'.repeat(Math.max(text.length, 4))}
      </span>
    </span>
  );
}
